	const loginBtn = document.querySelectorAll(".SSO_popup_login");  // simple login
	const registerBtn = document.querySelectorAll(".SSO_popup_register");  // cc register
	const eliteJoinBtn = document.querySelectorAll(".SSO_popup_elite_join"); // elite register
	const eliteUpgradeBtn = document.querySelectorAll(".SSO_popup_elite_upgrade"); // cc to elite memeber

	const popup = document.getElementById('new_popup-modal2');
	const close_popup = document.querySelector('#new_popup-modal2 .close_popup');
	const overlay = document.getElementById('new_popup-overlay2');

	const mainLoginForm = document.querySelector('.main_login_form')
	const mainSignupForm = document.querySelector('.main_signup_form') 
	const mainSignupEliteForm = document.querySelector('.main_elite_signup_form') 
	const mainEliteUpgradeForm = document.querySelector('.main_elite_upgrade_form');
	const renewMembershipPopup = document.querySelector('.subscribe_elite_membershop');
	const campaignRenewMembershipPopup = document.querySelector('.campaign_elite_membership');
	const popupOpened = localStorage.getItem('popupOpened');



// 
	// if (!popupOpened ) { 
	// 	console.log(localStorage.getItem('ageVerified'), "Age Verified");
	// 	setTimeout(() => { 
	// 		if(popupOpened != 'true' && localStorage.getItem('ageVerified') === 'true'){
	// 			localStorage.setItem("popupOpened", 'true' );
	// 			openPopup2('signup_form');
	// 		} 
	// 	}, 3000);
	// }
	// window.addEventListener('ageVerified', () => {
	// // prevent reopening if user already closed signup popup
	// 	if ( popupOpened === 'true') return;

	// 	setTimeout(() => {
	// 		localStorage.setItem("popupOpened", 'true' );
	// 		openPopup2?.('signup_form');
	// 	}, 500);
	// });

	const closePopup2 = function (firstTime = false) {
		popup.style.display = 'none';
		overlay.style.display = 'none';  

		if(firstTime) localStorage.setItem('popupClosed', 'true');
			localStorage.setItem('popupOpened', 'true');
	};


	
	openPopup2 = function (form) {
		if(form == 'login_form'){
			document.querySelectorAll('.new_forms').forEach(f=>f.classList.add('new_hidden'))
			mainLoginForm.classList.remove('new_hidden')
		}else if(form == 'signup_form'){
			document.querySelectorAll('.new_forms').forEach(f=>f.classList.add('new_hidden'))
			mainSignupForm.classList.remove('new_hidden')
		}else if( form == 'signup_elite_form'){
			document.querySelectorAll('.new_forms').forEach(f=>f.classList.add('new_hidden'))
			mainSignupEliteForm.classList.remove('new_hidden')
		}else if( form == 'signup_upgrade_form'){
			document.querySelectorAll('.new_forms').forEach(f=>f.classList.add('new_hidden'))
			mainEliteUpgradeForm.classList.remove('new_hidden')
		}
		popup.style.display = 'block';
		overlay.style.display = 'block';  
	}; 


	overlay.addEventListener('click',function(){
		if (!localStorage.getItem('popupClosed') || localStorage.getItem('popupClosed') != 'true'){
			closePopup2(true)
		}else{
			closePopup2()
		}
	})
	close_popup.addEventListener('click',function(){
		if (!localStorage.getItem('popupClosed') || localStorage.getItem('popupClosed') != 'true'){ 
			closePopup2(true)
		}else{
			closePopup2()
		}
	})



	loginBtn.forEach((btn) => {
		btn.addEventListener("click", (event) => {
            event.preventDefault();
			openPopup2('login_form')
		});
	});

	registerBtn.forEach((btn) => {
		btn.addEventListener("click", () => {
			openPopup2('signup_form')
		});
	});

	eliteJoinBtn.forEach((btn) => {
		btn.addEventListener("click", () => {
			openPopup2('signup_elite_form')
		});
	});

	eliteUpgradeBtn.forEach((btn) => {
		btn.addEventListener("click", () => { 
			openPopup2('signup_upgrade_form')
			
			// setTimeout(()=>{
			// 	if (!document.querySelector('#accept_policy')?.checked){

			// 	}else{
			// 		openPopup2('signup_upgrade_form')
			// 	}
			// },100)
						
		});
	});


	
	document.addEventListener('click',function(e){
		if(e.target.classList.contains('SSO_popup_elite_upgrade')){
			openPopup2('signup_upgrade_form')
		}
		// if(e.target.classList.contains('SSO_popup_register')){
		// 	openPopup2('signup_form')
		// }
		// if(e.target.classList.contains('SSO_popup_login')){
		// 	openPopup2('login_form')
		// }
	})

	document.addEventListener('click', function(e) {
    if (
        // e.target.classList.contains('SSO_popup_elite_upgrade') ||
        e.target.classList.contains('SSO_popup_register') ||
        e.target.classList.contains('SSO_popup_login')
    ) {
        e.preventDefault();

        const newsletterEmailInput = document.querySelector('#SSO__url_login_form input[type="email"]');
        const newsletterEmail = newsletterEmailInput ? newsletterEmailInput.value.trim() : '';
		
		  if (newsletterEmail) {
            setTimeout(() => {
                const popupEmailInput = document.querySelector('.new_forms:not(.new_hidden) input[type="email"]');
                if (popupEmailInput) {
                    popupEmailInput.value = newsletterEmail;
                }
            }, 50);
        }

        // if (e.target.classList.contains('SSO_popup_elite_upgrade')) {
        //     openPopup2('signup_upgrade_form');
        // }
        if (e.target.classList.contains('SSO_popup_register')) {
            openPopup2('signup_form');
        }
        if (e.target.classList.contains('SSO_popup_login')) {
            openPopup2('login_form');
        }
    }
});

openResubscribeMembership = function () {
  const renew_popup_opened = localStorage.getItem("renew_popup_open_once");
  console.log(renew_popup_opened);
  if(!renew_popup_opened) {
    const days_expires = localStorage.getItem("membership_expiring_in_days");
    renewMembershipPopup.querySelector(".expires_days").textContent = days_expires;
    mainLoginForm.classList.add('new_hidden');
    renewMembershipPopup.classList.remove('new_hidden');
    popup.style.display = 'block';
    overlay.style.display = 'block';
    localStorage.setItem("renew_popup_open_once", true)
    lockPageScroll();
  }
}
checkIfMembershipExpiring = function(date) {
const expiryDate = new Date(date);

localStorage.setItem("membership_expiry_date", expiryDate.toISOString());

const savedExpiry = localStorage.getItem("membership_expiry_date");

  if (savedExpiry) {
    const expiry = new Date(savedExpiry);
    const today = new Date();
	const within14Days =
    today >= expiry &&
    today <= new Date(expiry.getTime() + 14 * 24 * 60 * 60 * 1000);
    
    const diffTime = expiry - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    const membershipExpiringSoon = diffDays <= 30;

    localStorage.setItem("membership_expiring_soon", membershipExpiringSoon);
    localStorage.setItem("membership_expiring_in_days", diffDays);
	if( within14Days ) {
		localStorage.setItem("with_in_14_days", true );
	}

    console.log(`Membership expires in ${diffDays} days`);
    console.log("Expiring soon:", membershipExpiringSoon);
  }
}
async function handleMembershipRenewal() {
  const urlParams = new URLSearchParams(window.location.search);
  const isMembershipRenew = urlParams.get('membership_renew') === 'true';

  if (isMembershipRenew && !window.isCustomerLoggedIn) {
    campaignRenewMembershipPopup.classList.remove('new_hidden');
    popup.style.display = 'block';
    overlay.style.display = 'block';
    mainLoginForm.classList.add('new_hidden');
  }
  if (isMembershipRenew && window.isCustomerLoggedIn) {
    renewMembershipPopup.classList.remove('new_hidden');
    popup.style.display = 'block';
    overlay.style.display = 'block';
    mainLoginForm.classList.add('new_hidden');
  }

  const isMembershipRenewDirect = urlParams.get('membership_renew_direct') === 'true';

  if (isMembershipRenewDirect) {
    try {
      await addEliteProductToCart();
      window.location.href = "/checkout";
    } catch (error) {
      console.error('Error:', error);
    }
  }
}
if(window.enableRenew) { 
  handleMembershipRenewal();
}

document.addEventListener('DOMContentLoaded', function () {
  const campaignRenewBtn = document.querySelector('.login_to_renew');
  
  if (campaignRenewBtn) {
    campaignRenewBtn.addEventListener('click', function () {
      campaignRenewMembershipPopup?.classList.add('new_hidden');
      mainLoginForm?.classList.remove('new_hidden');
      popup.style.display = 'block';
      overlay.style.display = 'block';
    });
  }
});